import React from 'react';
import { Globe, Link as LinkIcon } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const WebsiteInfoForm = ({ data, onChange, submitted }) => {
  return (
    <div className={`p-6 rounded-2xl border transition-all ${submitted && (!data.title || !data.sub_title || !data.link || !data.button_text) ? "bg-red-50/30 border-red-200" : "bg-slate-50 border-slate-200"}`}>
      <div className="flex items-center gap-2 mb-6">
        <div className="p-2 bg-primary/10 text-primary rounded-lg">
          <Globe size={20} />
        </div>
        <h3 className="font-bold text-slate-800">CTA / Website Information</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Section Title <span className="text-red-500">*</span></Label>
            <Input 
              value={data.title} 
              className={(!data.title && submitted) ? "border-red-500" : ""}
              onChange={(e) => onChange(prev => ({ ...prev, title: e.target.value }))} 
              placeholder="e.g. Visit the Live Site"
            />
          </div>
          <div className="space-y-2">
            <Label>Section Subtitle <span className="text-red-500">*</span></Label>
            <Input 
              value={data.sub_title} 
              className={(!data.sub_title && submitted) ? "border-red-500" : ""}
              onChange={(e) => onChange(prev => ({ ...prev, sub_title: e.target.value }))} 
              placeholder="e.g. Experience the digital transformation yourself."
            />
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Website Link <span className="text-red-500">*</span></Label>
            <div className="relative">
              <LinkIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
              <Input 
                className={`pl-10 ${(!data.link && submitted) ? "border-red-500" : ""}`}
                value={data.link} 
                onChange={(e) => onChange(prev => ({ ...prev, link: e.target.value }))} 
                placeholder="https://example.com"
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Button Text <span className="text-red-500">*</span></Label>
            <Input 
              value={data.button_text} 
              className={(!data.button_text && submitted) ? "border-red-500" : ""}
              onChange={(e) => onChange(prev => ({ ...prev, button_text: e.target.value }))} 
              placeholder="e.g. Launch Project"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteInfoForm;
